(function () {
    'use strict';

    angular
        .module('ib-apis-form-module')
        .service('ApisFormModel', ApisFormModel);

    function ApisFormModel() {

        this.apisPassengerInfo = {};
        this.showData = {};
        this.infoHeader;
        this.initializeModel = initializeModel;
        this.gdprInfo;
        function initializeModel() {
            this.apisPassengerInfo = {};
            this.showData = {};
        }
    }
})();